

export default class TypedRegistry<T> {

	private registered: { [key: string]: T; } = {};
	private getKey: (o: T) => string;

	public constructor(getKey: (o: T) => string) {
		this.getKey = getKey;
		this.registered = {};
	}

	public getObject(key: string): T | null {
		return this.registered[key] || null;
	}

	public getAll(): T[] {
		return Object.values(this.registered);
	}

	public putObject(o: T): T {
		const key = this.getKey(o);

		if (!!key && !this.registered[key]) {
			this.registered[key] = o;
		}

		return o;
	}
}



// WEBPACK FOOTER //
// ./src/core/util/TypedRegistry.ts